import { TimetableControlTypes } from './TimeTable';
export var ControlsType;
(function (ControlsType) {
    ControlsType["SCHEDULER"] = "Scheduler";
    ControlsType["COOLING"] = "Cooling";
    ControlsType["HEATING"] = "Heating";
    ControlsType["ENERGY_DEMAND_MANAGEMENT"] = "Energy Demand Management";
    ControlsType["HVAC"] = "HVAC";
    ControlsType["LIGHT_SENSOR"] = "Light Sensor";
})(ControlsType || (ControlsType = {}));
export var WorkingMode;
(function (WorkingMode) {
    WorkingMode["CALIBRATION"] = "CALIBRATION";
    WorkingMode["FORCE_ON"] = "FORCE_ON";
    WorkingMode["FORCE_OFF"] = "FORCE_OFF";
    WorkingMode["NORMAL"] = "NORMAL";
})(WorkingMode || (WorkingMode = {}));
export var WorkingModeLabel;
(function (WorkingModeLabel) {
    WorkingModeLabel["CALIBRATION"] = "Manual";
    WorkingModeLabel["FORCE_ON"] = "Force On";
    WorkingModeLabel["FORCE_OFF"] = "Force Off";
    WorkingModeLabel["NORMAL"] = "Auto";
})(WorkingModeLabel || (WorkingModeLabel = {}));
export var OutsideOfTimeTable;
(function (OutsideOfTimeTable) {
    OutsideOfTimeTable["ALTERNATIVE_SET_POINTS"] = "Alternative Set Points";
    OutsideOfTimeTable["OFF"] = "Off";
})(OutsideOfTimeTable || (OutsideOfTimeTable = {}));
export var ControlsTypeEntities;
(function (ControlsTypeEntities) {
    ControlsTypeEntities["SCHEDULER"] = "Scheduler";
    ControlsTypeEntities["TEMPERATURE"] = "TemperatureControl";
    ControlsTypeEntities["HVAC"] = "HVACControl";
})(ControlsTypeEntities || (ControlsTypeEntities = {}));
export const ControlTypesToDisplayTextsMapping = {
    [ControlsType.SCHEDULER]: 'Scheduler',
    [ControlsType.ENERGY_DEMAND_MANAGEMENT]: 'Energy Demand Management',
    [ControlsType.HVAC]: 'HVAC',
    [TimetableControlTypes.VENSTAR_HVAC]: 'HVAC',
    [ControlsType.LIGHT_SENSOR]: 'Scheduler',
    [TimetableControlTypes.LIGHT_SENSOR]: 'Scheduler',
    [TimetableControlTypes.SCHEDULER]: 'Scheduler',
};
export const ControlTypeFiltersList = [
    ControlTypesToDisplayTextsMapping[ControlsType.SCHEDULER],
    ControlTypesToDisplayTextsMapping[ControlsType.HVAC],
];
export var ControlsOverviewType;
(function (ControlsOverviewType) {
    ControlsOverviewType["CONTROLS_ACTIVE"] = "controlsActive";
    ControlsOverviewType["CONTROLS_OVERRIDDEN"] = "controlsOverriddenThroughSoftware";
    ControlsOverviewType["CONTROLS_RUNNING_AS_PLANNED"] = "controlsRunningAsPlanned";
    ControlsOverviewType["EQUIPMENT_IN_LOCAL_OVERRIDE"] = "equipmentInLocalOverride";
})(ControlsOverviewType || (ControlsOverviewType = {}));
export var ControlsOverviewLabel;
(function (ControlsOverviewLabel) {
    ControlsOverviewLabel["controlsRunningAsPlanned"] = "On Schedule";
    ControlsOverviewLabel["controlsOverriddenThroughSoftware"] = "System Override";
    ControlsOverviewLabel["equipmentInLocalOverride"] = "Active Local Override";
})(ControlsOverviewLabel || (ControlsOverviewLabel = {}));
export const WorkingModeMap = {
    0: WorkingMode.NORMAL,
    1: WorkingMode.FORCE_OFF,
    2: WorkingMode.FORCE_ON,
    3: WorkingMode.CALIBRATION,
};
export var TimetableScheduleType;
(function (TimetableScheduleType) {
    TimetableScheduleType["OCCUPIED"] = "Occupied";
    TimetableScheduleType["UNOCCUPIED"] = "Unoccupied";
    TimetableScheduleType["LOCAL_ADJUSTMENT"] = "Local Adjustment";
    TimetableScheduleType["LOCAL_OVERRIDE"] = "Local Override";
    TimetableScheduleType["EDM_OVERRIDE_ACTIVE"] = "EDM Override Active";
    TimetableScheduleType["UNREPORTED"] = "Unreported";
})(TimetableScheduleType || (TimetableScheduleType = {}));
